// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1_pqF","cls2":"WinBackPing-cls2_MMt WinBackPing-cls1_pqF"};